import { MessageCircle } from 'lucide-react';
import { useState } from 'react';

export const FloatingWhatsApp = () => {
  const [showTooltip, setShowTooltip] = useState(false);

  const handleWhatsAppClick = () => {
    // Using the official WhatsApp API format with proper encoding
    const phoneNumber = '60165264131';
    const message = encodeURIComponent('Hi, I am interested in discussing a growth opportunity.');
    const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${message}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="fixed bottom-6 right-6 z-[10000]">
      <div className="relative">
        {/* Tooltip */}
        {showTooltip && (
          <div className="absolute right-full mr-3 top-1/2 transform -translate-y-1/2 bg-[#F5F5F5] text-[#0a0a0a] px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap shadow-lg">
            Chat on WhatsApp
          </div>
        )}
        
        {/* WhatsApp Button */}
        <button
          className="w-14 h-14 bg-[#25D366] hover:bg-[#25D366]/90 rounded-full flex items-center justify-center shadow-lg transition-all hover:scale-110"
          onClick={handleWhatsAppClick}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
          aria-label="Chat on WhatsApp"
        >
          <MessageCircle className="w-7 h-7 text-white" />
        </button>
      </div>
    </div>
  );
};